<vgb-app-bar *ngIf="showAppBar"
             @appBarTransition></vgb-app-bar>

<main>
    <router-outlet *ngIf="!loading"></router-outlet>
    <div *ngIf="loading"
         id="app-module-loading"><span></span></div>
</main>